import { Search } from 'lucide-react'
import { InputHTMLAttributes, forwardRef } from 'react'

const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => {
    return (
      <input
        className={`flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export function HeroSection() {
  return (
    <section className="relative h-[500px] flex items-center justify-start">
      <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ 
          backgroundImage: "url('/assets/images/blog/young-handsome-physician-medical-robe-with-stethoscope.png')",
          
          backgroundBlendMode: 'overlay',
        }}
      />
      <div className="relative z-10 max-w-4xl mx-auto md:mt-10 md:ml-24 px-4 ">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-white ">
          We inform you for{" "}
          <br />
          <span className="text-blue-primary">better prevention.</span>
        </h1>
        <div className="relative max-w-xl mx-auto">
          <Input
            type="search"
            placeholder="Search subject"
            className="w-full h-12 pl-4 pr-12 rounded-full bg-white/95"
          />
          <Search className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 h-5 w-5" />
        </div>
      </div>
    </section>
  )
}

